module.exports = __webpack_public_path__ + "static/media/close_tag.2700bb9a.svg";